import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { get_all_interview_kit_data_action } from "../../../redux/_actions";
function useMentorAssessmentKits(props) {
  const [loading, setLoading] = useState(false);
  const [assessmentKits, setAssessmentKits] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allInterviewKitsData } = useSelector(
    (state) => state.get_all_interview_kit_data_reducer
  );
  useEffect(() => {
    getAssessmentKits();
  }, []);

  useEffect(() => {
    if (allInterviewKitsData?.data) {
      setAssessmentKits(allInterviewKitsData?.data);
    }
  }, [allInterviewKitsData]);

  const getAssessmentKits = async () => {
    setLoading(true);
    await dispatch(get_all_interview_kit_data_action());
    setLoading(false);
  };

  // time_to_answer

  const countQuestions = (data) => {
    let total_question = 0;
    Array.isArray(data) &&
      data.forEach((element) => {
        total_question =
          Array.isArray(element?.questions) &&
          element?.questions &&
          element.questions.length + total_question;
      });
    return total_question;
  };
  const onViewCandidatesClick = (interviewKit) => {
    navigate(`/submitted-candidates-assessments/${interviewKit}`);
  };

  const onEditKitClick = (id) => {
    navigate(`/create-assessment/${id}`);
  };

  return {
    loading,
    assessmentKits,
    countQuestions,
    onEditKitClick,
    onViewCandidatesClick,
  };
}
export default useMentorAssessmentKits;
